import Hero from "./Hero";
import Products from "./Products";
import WhyChooseUs from "./ProductList";
import ProductList from "./ProductList";
import Contact from "./Contact";
import { Link } from "react-router-dom";
export default function Home(){

    return(
        <>
<Hero/>

{/* <!--feature start--> */}
<section>
      <div className="container">
        <div
          className="row gx-lg-4 justify-content-center"
          style={{ columnGap: "20px" }}
        >
          <div className="row justify-content-center text-center">
            <div className="col-xl-6 col-lg-8 col-md-12">
              <div className="theme-title">
                <h6>CATEGORIES</h6>
                <h2>
                  Comprehensive Solutions For <span>Every Challenge.</span>
                </h2>
              </div>
            </div>
          </div>

          {/* Peptides */}
          <div className="col-lg-3 col-md-6 mt-6 mt-md-0">
            <div className="featured-item style-1 featured-active">
              <div className="service-item style-3">
                <div className="service-img">
                  <Link to="/peptidesSection" state={{ category: "PEPTIDES" }}>
                    <img
                      className="img-fluid"
                      src="assets/images/service/01.jpg"
                      alt="Peptides"
                    />
                  </Link>
                </div>
                <div className="service-desc text-center">
                  <div className="service-title">
                    <Link to="/peptidesSection" state={{ category: "PEPTIDES" }}>
                      <h4>PEPTIDES</h4>
                    </Link>
                  </div>
                  <p>
                    Solutions are involved in various metabolic pathways,
                    like glycolysis, where glucose is converted to pyruvate.
                  </p>
                  <Link
                    className="ht-link-btn"
                    to="/peptidesSection"
                    
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="arr-2"
                      viewBox="0 0 24 24"
                    >
                      <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                    </svg>
                    <span>Read More</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="arr-1"
                      viewBox="0 0 24 24"
                    >
                      <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Injectables */}
          <div className="col-lg-3 col-md-6 mt-6 mt-lg-0">
            <div className="featured-item style-1 featured-active">
              <div className="service-item style-3">
                <div className="service-img">
                  <Link to="/injectableSection" state={{ category: "INJECTABLES" }}>
                    <img
                      className="img-fluid"
                      src="assets/images/service/03.jpg"
                      alt="Injectables"
                    />
                  </Link>
                </div>
                <div className="service-desc text-center">
                  <div className="service-title">
                    <Link to="/injectableSection" state={{ category: "INJECTABLES" }}>
                      <h4>INJECTABLES</h4>
                    </Link>
                  </div>
                  <p>
                    Solutions are involved in various metabolic pathways,
                    like glycolysis, where glucose is converted to pyruvate.
                  </p>
                  <Link
                    className="ht-link-btn"
                    to="/injectableSection"
                    state={{ category: "INJECTABLES" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="arr-2"
                      viewBox="0 0 24 24"
                    >
                      <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                    </svg>
                    <span>Read More</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="arr-1"
                      viewBox="0 0 24 24"
                    >
                      <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Tablets */}
          <div className="col-lg-3 col-md-6 mt-6 mt-lg-0">
            <div className="featured-item style-1 featured-active">
              <div className="service-item style-3">
                <div className="service-img">
                  <Link to="/tabletssection" state={{ category: "TABLETS" }}>
                    <img
                      className="img-fluid"
                      src="assets/images/service/02.jpg"
                      alt="Tablets"
                    />
                  </Link>
                </div>
                <div className="service-desc text-center">
                  <div className="service-title">
                    <Link to="/tabletssection" state={{ category: "TABLETS" }}>
                      <h4>TABLETS</h4>
                    </Link>
                  </div>
                  <p>
                    Solutions are involved in various metabolic pathways,
                    like glycolysis, where glucose is converted to pyruvate.
                  </p>
                  <Link
                    className="ht-link-btn"
                    to="/tabletssection"
                    
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="arr-2"
                      viewBox="0 0 24 24"
                    >
                      <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                    </svg>
                    <span>Read More</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="arr-1"
                      viewBox="0 0 24 24"
                    >
                      <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="animated-icon-shape">
        <img
          className="img-fluid small-circle-animation"
          src="assets/images/small-icon/01.png"
          alt=""
        />
        <img
          className="img-fluid small-circle-animation"
          src="assets/images/small-icon/02.png"
          alt=""
        />
        <img
          className="img-fluid small-circle-animation"
          src="assets/images/small-icon/03.png"
          alt=""
        />
        <img
          className="img-fluid small-circle-animation"
          src="assets/images/small-icon/04.png"
          alt=""
        />
      </div>
    </section>

{/* <!--feature end--> */}

<Products/>

{/* <!--marquee start--> */}

<section class="overflow-hidden p-0">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col">
        <div class="marquee-wrap">
          <div class="marquee-text">
            <span>olympians</span>
            <span>Laboratory</span>
            <span>Science</span>
            <span>Laboratory</span>
            <span>Science</span>
            <span>olympians</span>
            <span>Laboratory</span>
            <span>Science</span>
            <span>Research</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

{/* <!--marquee end--> */}

{/* <!--about start--> */}

<section>
  <div class="container">
    <div class="row align-items-center justify-content-between">
      <div class="col-lg-6 col-12">
        <div class="row g-0">
          <div class="col-md-6 mb-4 mb-md-0">
            <div class="about1-img-shape w-100 h-100">
          <img class="img-fluid" src="assets/images/about/01.jpg" alt=""/>
        </div>
          </div>
          <div class="col-md-6 mb-4 mb-md-0">
            <div class="about1-img-shape w-100 h-100">
          <img class="img-fluid" src="assets/images/about/02.jpg" alt=""/>
        </div>
          </div>
        </div>
        <div class="row g-0 mt-md-n5 justify-content-center text-center">
          <div class="col-md-6">
            <div class="about1-img-shape w-100 h-100">
          <img class="img-fluid" src="assets/images/about/08.jpg" alt=""/>
        </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12 mt-6 mt-lg-0 ps-lg-8">
        <div class="theme-title">
          <h6>About Us</h6>
          <h2>Experiment With The Best <span>Lab Test And Service</span></h2>
          <p>Our journey is a testament to our pursuit of a healthier tomorrow, as we are steadfast in our mission to ensure progressive and advanced healthcare solutions for patients in need. Our commitment is to enhance the quality of living while building an engaging, enriching, and empowering culture at Olympians.</p>
        </div>
        <div class="row mt-4 mb-3">
          <div class="col-md-6">
            <ul class="list-unstyled list-icon style-2 mb-0">
              <li class="mb-3">
                <i class="bi bi-check2-all"></i> Toxicological assessment
              </li>
              <li>
                <i class="bi bi-check2-all"></i> Diagnostic research Facility
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul class="list-unstyled list-icon style-2 mb-0">
              <li class="mb-3">
                <i class="bi bi-check2-all"></i> Basic Pathology Testing
              </li>
              <li class="mb-3">
                <i class="bi bi-check2-all"></i> Biological evaluation
              </li>
            </ul>
          </div>
        </div>
        <hr class="border border-light"/>
        <div class="row mt-5 mb-5">
          {/* <div class="col-md-6">
           <a class="themeht-btn primary-btn" href="about-us.html">More About Us</a>
          </div> */}
          <div class="col-md-6 mt-3 mt-md-0">
            {/* <div class="d-flex align-items-center">
              <div class="flex-shrink-0">
                <img class="rounded-circle" src="assets/images/about-thumb.jpg" alt="..."/>
              </div>
              <div class="flex-grow-1 ms-3">
                <h6 class="mb-0">Dr. Abigail George</h6>
                <label class="text-theme">Laboratory Specialist</label>
              </div>
            </div> */}
          </div>
        </div>
       
      </div>
    </div>
  </div>
</section>

{/* <!--about end--> */}






  <div className="container">
    <div className="row gx-lg-4 text-center">
      <div className="col-lg-3 col-md-6">
        <div className="featured-item style-1 d-flex flex-column align-items-center">
        <div className="featured-icon mb-1 mt-5">
            <i className="flaticon flaticon-chemistry-2"></i>
          </div>
          <div className="featured-desc p-4">
            <div className="featured-title">
              <h4>Purity and Quality</h4>
              <p>Uncompromising</p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
        <div className="featured-item style-1 featured-active d-flex flex-column align-items-center">
        <div className="featured-icon mb-1 mt-5">
            <i className="flaticon flaticon-biochemistry-1"></i>
          </div>
          <div className="featured-desc p-4">
            <div className="featured-title">
              <h4>Technology</h4>
              <p>Cutting-Edge</p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 mt-4 mt-lg-0">
        <div className="featured-item style-1 d-flex flex-column align-items-center">
                <div className="featured-icon mb-1 mt-5">
            <i className="flaticon flaticon-chemistry-4"></i>
          </div>
          <div className="featured-desc p-4">
            <div className="featured-title">
              <h4>Standards</h4>
              <p>Rigorous Testing</p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 mt-4 mt-lg-0">
        <div className="featured-item style-1 d-flex flex-column align-items-center">
           <div className="featured-icon mb-1 mt-5">
            <i className="flaticon flaticon-biochemistry"></i>
          </div>
          <div className="featured-desc p-4">
            <div className="featured-title">
              <h4>Professionals</h4>
              <p>Expert Team</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="container pt-5">
    <div className="row gx-lg-4 text-center">
      <div className="col-lg-3 col-md-6">
        <div className="featured-item style-1 d-flex flex-column align-items-center">
          <div className="featured-icon  mb-1 mt-5 style-1 ">
            <i className="flaticon flaticon-chemistry-2"></i>
          </div>
          <div className="featured-desc p-4">
            <div className="featured-title">
              <h4>Sustainable Practices</h4>
              <p>Sustainable and Ethical</p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 mt-4 mt-md-0">
        <div className="featured-item style-1 featured-active d-flex flex-column align-items-center">
        <div className="featured-icon mb-1 mt-5">
            <i className="flaticon flaticon-biochemistry-1"></i>
          </div>
          <div className="featured-desc p-4">
            <div className="featured-title">
              <h4>Excellence</h4>
              <p>Global Reputation for</p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 mt-4 mt-lg-0">
        <div className="featured-item style-1 d-flex flex-column align-items-center">
     <div className="featured-icon mb-1 mt-5">
            <i className="flaticon flaticon-chemistry-4"></i>
          </div>
          <div className="featured-desc p-4">
            <div className="featured-title">
              <h4>Approach</h4>
              <p>Customer-Centric</p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 mt-4 mt-lg-0">
        <div className="featured-item style-1 d-flex flex-column align-items-center">
          <div className="featured-icon mb-1 mt-5">
            <i className="flaticon flaticon-biochemistry"></i>
          </div>
          <div className="featured-desc p-4">
            <div className="featured-title">
              <h4>Equipment</h4>
              <p>Advanced Laboratory</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Animated Icons */}
  <div className="animated-icon-shape text-center mt-5">
    <img className="img-fluid small-circle-animation mx-2" src="images/small-icon/01.png" alt="" />
    <img className="img-fluid small-circle-animation mx-2" src="images/small-icon/02.png" alt="" />
    <img className="img-fluid small-circle-animation mx-2" src="images/small-icon/03.png" alt="" />
    <img className="img-fluid small-circle-animation mx-2" src="images/small-icon/04.png" alt="" />
  </div>















<div class="page-content">
<section class="pt-5">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12 order-lg-1">
        <img class="img-fluid topBottom" src="assets/images/appointment-img.png" alt=""/>
      </div>
      <div class="col-lg-6 col-md-12 mt-10 mt-lg-0 pe-lg-10">
        <div class="box-shadow rounded p-5">
          <div class="theme-title">
          <h6>Get in Touch</h6>
          <h2>Olymipian <span>Laboratories</span>
          </h2>
        </div>
          <form id="contact-form" method="post" action="php/contact.php">
          <div class="messages"></div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Your Name</label>
                <input id="form_name" type="text" name="name" class="form-control" placeholder="Enter Your Name" required="required" data-error="Name is required."/>
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email Address</label>
                <input id="form_email" type="email" name="email" class="form-control" placeholder="Enter Email Address" required="required" data-error="Valid email is required."/>
                <div class="help-block with-errors"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Phone Number</label>
                <input id="form_phone" type="tel" name="phone" class="form-control" placeholder="Enter Phone number" required="required" data-error="Phone is required"/>
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Select Product-Type</label>
                <select class="form-control form-select" aria-label="Default select example">
                  <option selected>Select Service</option>
                  <option value="1">TABLETS</option>
                  <option value="2">PEPTIDES</option>
                  <option value="3">INJECTABLES</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Message</label>
                <textarea id="form_message" name="message" class="form-control" placeholder="Write Your Message Here..." rows="4" required="required" data-error="Please,leave us a message."></textarea>
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-md-12 mt-3">
              <button class="themeht-btn primary-btn">
                Send Message
              </button>
            </div>
          </div>
        </form>

      </div>
        
      </div>
    </div>
  </div>
</section>




</div>
        
        </>
    )
}